import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';
import HotelDetail from './HotelDetail';
import HotelSummary from './HotelSummary';

class HotelDetailWithToggle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDetail: props.showDetail,
    };
    this.showDetail = this.showDetail.bind(this);
    this.hideDetail = this.hideDetail.bind(this);
  }
  showDetail() {
    this.setState({ showDetail: true });
  }
  hideDetail() {
    this.setState({ showDetail: false });
  }

  render() {
    const { hotel } = this.props;
    if (!this.state.showDetail) {
      return (
        <div>
          <HotelSummary hotel={hotel} distanceTo={this.props.distanceTo} />
          <Button onClick={this.showDetail}>Show Detail</Button>
        </div>
      );
    }
    return (
      <div>
        <HotelDetail hotel={hotel} distanceTo={this.props.distanceTo} />
        <Button onClick={this.hideDetail}>Hide Detail</Button>
      </div>
    );
  }
}

HotelDetailWithToggle.propTypes = {
  hotel: PropTypes.object.isRequired,
  distanceTo: PropTypes.object,
  showDetail: PropTypes.bool,
};
HotelDetailWithToggle.defaultProps = {
  showDetail: false,
};

export default HotelDetailWithToggle;



// WEBPACK FOOTER //
// src/components/HotelDetail/HotelDetailWithToggle.js